import { cn } from "@/lib/utils";

// Slow editorial marquee ribbon. Duplicated content + CSS animation keeps
// this dependency-free and cheap to render.
export const Marquee = ({ text, dark = true, className }) => (
  <div
    data-testid="editorial-marquee"
    className={cn(
      "relative overflow-hidden whitespace-nowrap border-y py-5",
      dark ? "border-border-dark bg-brand-black" : "border-border-light bg-white",
      className
    )}
  >
    <div className="flex w-max animate-marquee items-center gap-10">
      {[0, 1].map((rep) => (
        <div key={rep} className="flex shrink-0 items-center gap-10">
          {text.map((item, i) => (
            <span
              key={`${rep}-${i}`}
              className={cn(
                "font-heading text-5xl uppercase sm:text-7xl",
                dark ? "text-outline-white" : "text-outline-black"
              )}
            >
              {item}
              <span className="mx-10 inline-block h-3 w-3 rounded-full bg-brand-purple align-middle" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
